import { useEffect, useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import Select from "react-select";
import { useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import { FoldDown, FoldRight } from "../../Static/icons/iconshere";
import apiClient from "../../apiClient";
import { CREATE_AR_ASSET_MODULE, FETCH_AR_ASSET_FILE, SAVE_AR_3D_ASSET } from "../../apiClient/apiEndpoints";
import { downloadFileFromUrl, getAllowedMaxFileSize, getFileSize, isFileSizeOverMaxSize } from "../../utils/common";
import { debounce } from "../../utils/useWindowDimensions";
import { AR_CONTENT_3D_MODEL } from "../../constant/limitSize";

let defaultAr3DModel = {
  name: null,
  size: null,
  url: null,
  file: null,
  preview: null,
  loading: false,
  error: false,
  percentage: 0,
};

const fileTypes = ["JPG", "PNG", "GIF"];

const PlatformOptions = [
  { label: "Android", value: "mobile" },
  { label: "iOS", value: "iOS" },
];
const AssetsTypeOptions = [
  { label: "Addressable", value: "addressable" },
  { label: "Asset Bundle", value: "ab" },
];

const ARContentUpload = ({ uuid, setThreeDModelsList }) => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const [assetPlatform, setAssetPlatform] = useState({ label: "Android", value: "mobile" });
  const [assetType, setAssetType] = useState({ label: "Addressable", value: "addressable" });
  const [assetVersionFiles, setAssetFiles] = useState([]);
  const [key, setKey] = useState(0);
  const [fileError, setFileError] = useState(null);
  const [uploadAssetFile, setUploadAssetFile] = useState(defaultAr3DModel);
  const [close, setClose] = useState(false);
  const [fileSaveLoading, setFileSaveLoading] = useState(false);
  const controllerRef = useRef(null);

  const getArModuleAssetVersions = async () => {
    try {
      let data = await apiClient.get(`${configData?.config?.UNO_URL}${FETCH_AR_ASSET_FILE}/${assetPlatform.value}/${uuid}`)
      setAssetFiles(data?.versions || [])
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getArModuleAssetVersions();
  }, [uuid, assetPlatform]);

  const handleFileUpload = async (uploadedFile) => {

    setFileError(null);
    if (isFileSizeOverMaxSize(uploadedFile.size, AR_CONTENT_3D_MODEL)) {
      setKey((pre) => pre + 1);
      setFileError(`File size is more then ${getAllowedMaxFileSize(AR_CONTENT_3D_MODEL)}`);
      return
    }

    try {
      const platform = assetPlatform.value;
      const formData = new FormData();
      formData.append("file", uploadedFile);

      setUploadAssetFile((pre) => ({
        ...pre,
        name: uploadedFile.name,
        size: getFileSize(uploadedFile.size),
        loading: true,
        file: uploadedFile,
      }));

      if (controllerRef.current) {
        controllerRef.current.abort(); // Cancel any previous request
      }
      controllerRef.current = new AbortController();

      let { data } = await axios.post(
        `${configData?.config?.UNO_URL}${SAVE_AR_3D_ASSET}/${uuid}/${platform}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
            "Content-Type": "multipart/form-data",
          },
          signal: controllerRef.current.signal,
          onUploadProgress: (progressEvent) => {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadAssetFile((pre) => ({
              ...pre,
              percentage: percent === 100 ? 99 : percent,
            }));
          },
        }
      );

      setUploadAssetFile((pre) => ({
        ...pre,
        loading: false,
        url: data.url,
        percentage: 100,
      }));
    } catch (error) {
      console.log(error);
      setUploadAssetFile((pre) => ({
        ...pre,
        loading: false,
        error: true,
      }));
    }
  };

  const handleCancelUpload = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
      setUploadAssetFile({ ...defaultAr3DModel });
    }
  };

  const handleSaveNewVersion = async () => {
    if (fileSaveLoading) return;

    try {
      let bodyData = {
        type: assetType.value,
        assets: [{
          url: uploadAssetFile.url,
          level: "Level 0",
        }]
      }

      await apiClient.post(`${configData?.config?.UNO_URL}${CREATE_AR_ASSET_MODULE}/${uuid}/${assetPlatform.value}`, bodyData);
      setUploadAssetFile({ ...defaultAr3DModel });
    } catch (error) {
      console.log(error);
    } finally {
      setFileSaveLoading(false);
      getArModuleAssetVersions();
    }
  };

  useEffect(() => {
    setThreeDModelsList(assetVersionFiles);
  }, [assetVersionFiles]);


  const handleDownloadFile = (file) => {
    let fileUrl = file?.data?.assets?.[0]?.url || null;
    fileUrl && downloadFileFromUrl(fileUrl);
  };

  const debounceHandleSaveReview = debounce(handleSaveNewVersion, 500, setFileSaveLoading);

  let filterAssetVersionFiles = assetVersionFiles.filter(e => e.data.type === assetType.value);

  return (
    <div className={`detail-component  mt-3 ${close ? "closed" : ""} `}>
      <h6>
        Upload 3D Model
        <span className="OpenCloseBtn" onClick={() => setClose((prev) => !prev)}>
          {!close ? <FoldDown /> : <FoldRight />}
        </span>{" "}
      </h6>
      <div className="uploadBoxParent">
       
          <div className="uploadBoxItem">
          <div className="uploadBoxHead">
            <p>Upload Model File</p>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group ps-0 pt-2">
                <label htmlFor="exampleFormControlInput1">
                  Select Platform <span> * </span>
                </label>
                <Select
                  name="Object"
                  className="basic-multi-select mt-2"
                  classNamePrefix="select"
                  placeholder="Select Platform"
                  createNewCustomTags
                  options={PlatformOptions}
                  onChange={(value) => setAssetPlatform(value)}
                  value={assetPlatform}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group ps-0 pt-2">
                <label htmlFor="exampleFormControlInput1">
                  Select Asset Type <span> * </span>
                </label>
                <Select
                  name="Object"
                  className="basic-multi-select mt-2"
                  classNamePrefix="select"
                  placeholder="Select Asset Type"
                  createNewCustomTags
                  options={AssetsTypeOptions}
                  onChange={(value) => setAssetType(value)}
                  value={assetType}
                />
              </div>
            </div>
          </div>

          <div className="fileuploader">
            {!uploadAssetFile.file ? (
              <FileUploader
                key={key}
                name="thumbnailInput"
                // types={fileTypes}
                label="drag & drop or choose file to upload"
                handleChange={(file) => handleFileUpload(file)}
              />
            ) : (
              <div className="file-uploadingView">
                <div className="uploadItem">
                  <p> {uploadAssetFile.name} </p>
                  <div className="size-data">
                    <span className="fileSize">{uploadAssetFile.size}</span>
                    <span className="percentage"> {`${uploadAssetFile.percentage} %`} </span>
                  </div>

                  {!uploadAssetFile.url && (
                    <div className="uploadStatus">
                      <span className="complete" style={{ width: `${uploadAssetFile.percentage}%` }}>
                        {" "}
                      </span>
                    </div>
                  )}

                  <div className="action-btns">
                    <button onClick={handleCancelUpload}> Cancel </button>
                    <button disabled={uploadAssetFile.url ? false : true} onClick={debounceHandleSaveReview}>
                      {" "}
                      Save{" "}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <p className="error" >{fileError}</p>
          <div class="uploadpromt">Max file size: {getAllowedMaxFileSize(AR_CONTENT_3D_MODEL)}</div> 
        </div>

        <div className="uploadBoxItem">
          <div className="uploadBoxHead">
            <p>Version History</p>
          </div>
          <div className="mediaList">
            <div className="table-responsive workflowtb mt-2 stickyhead ">
              <table className="table align-middle table-nowrap mb-0">
                <thead>
                  <tr>
                    <th className="w-50">Version Name</th>
                    <th className="text-center">File Type</th>
                    <th className="text-center">Timestamp</th>
                  </tr>
                </thead>

                <tbody className="versiontable">
                  {filterAssetVersionFiles?.map(item => (
                    <tr>
                      <td onClick={() => handleDownloadFile(item)} > <a href=""> {item.version} </a> </td>
                      <td className="text-center"> {item.data.type} </td>
                      <td className="text-center"> {moment(item.createdAt).format("LLL")} </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ARContentUpload;
